// src/store/user/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: null,
  email: null,
  profilePic: null,      // e.g., 'avatar.jpg'
  profilePicData: null,  // stored actual image data (or object URL)
  points: 0,
  token: null,
  status: 'idle',        // idle | loading | succeeded | failed
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,

  /*----  Redux-Saga will dispatch these: ----*/
  reducers: {


    /*--- Fetching userData ---*/

    fetchUserDataRequest: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    fetchUserDataSuccess: (state, action) => {
      state.status = 'succeeded';
      const { name, email, profilePic, points, token } = action.payload;
      state.name = name;
      state.email = email;
      state.profilePic = profilePic;
      state.points = points;
      state.token = token;
    },
    fetchUserDataFailure: (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    },

    /*--- Fetching userData ---*/



    /*--- Fetching user’s profilePic ---*/

    fetchUserProfilePicRequest: (state, action) => {
      // you could track a separate status or do something else
    },
    fetchUserProfilePicSuccess: (state, action) => {
      state.profilePicData = action.payload;
    },
    fetchUserProfilePicFailure: (state, action) => {
      state.error = action.payload;
    },

    /*--- Fetching user’s profilePic ---*/



    /*---- Existing reducers ----*/

    setUser: (state, action) => {
      const { name, email, profilePic, profilePicBase64, points, token } = action.payload;
      state.name = name;
      state.email = email;
      state.profilePic = profilePic;
      state.profilePicBase64 = profilePicBase64;
      state.points = points;
      state.token = token;
    },
    clearUser: (state) => {
      state.name = null;
      state.email = null;
      state.profilePic = null;
      state.profilePicData = null;
      state.points = 0;
      state.token = null;
      state.status = 'idle';
      state.error = null;
    },

    /*---- Existing reducers ----*/


  },
});

export const {
  fetchUserDataRequest,
  fetchUserDataSuccess,
  fetchUserDataFailure,
  fetchUserProfilePicRequest,
  fetchUserProfilePicSuccess,
  fetchUserProfilePicFailure,
  setUser,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer;


